module.exports = __webpack_public_path__ + "img/task_type_setting.f237e32.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/task_type_setting.svg
// module id = leL9
// module chunks = 1